import { atomWithReset, selectAtom } from "jotai/utils";
import { iAssignmentPositions, raidAreas, targets, roles, lists, assignments } from "typings";

export const targetsState = atomWithReset<targets>({})
export const rolesState = atomWithReset<roles>({})
export const listsState = atomWithReset<lists>({})
export const assignmentsState = atomWithReset<assignments>({})
export const assignmentPosState = atomWithReset<iAssignmentPositions>({ links: [], sections: {}, rootSectionOrder: [] })
export const aPosLinksDerivedState = selectAtom(assignmentPosState, (aPos) => aPos.links)
export const areasState = atomWithReset<raidAreas>({})